// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { DEFAULT_VALUES } from "@libraries/web-framework";
import { FormattedMessage, useIntl } from "react-intl";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "../../../../components/wpl/button/src/index";
import { Link } from "../../../../components/wpl/link/src/index";

const backgroundStyles = css`
    flex-direction: column;
    margin: auto 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    align-items: stretch;
    overflow: hidden;
    text-align: center;
    background: #9fc365;
    border-radius: 3px;
    max-width: 1440px;

    ${media.above.sm} {
        display: flex;
        width: 600px;
        margin: auto;
        flex-direction: row;
        gap: unset;
    }
    ${media.above.md} {
        width: unset;
        margin: auto 16px;
        text-align: left;
        background: none;
        border-radius: 0;
        background-image: url(https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_banner_background_11_14_23.webp);
        background-size: 100% 100%;
    }
`;

const titleImageStyles = css`
    flex: 1 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 34px;
    box-sizing: border-box;

    ${UNSAFE_media.below.md} {
        display: none;
    }

    ${media.above.sm} {
        padding: ${token("space.400")} ${token("space.200")}
            ${token("space.200")} ${token("space.200")};
    }

    img {
        max-width: 100%;
        height: 70px;
    }
`;

const descriptionStyles = css`
    display: flex;
    flex: 1 75%;
    flex-direction: column;
    align-items: center;
    padding-bottom: 22px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 22px;
    box-sizing: border-box;
    gap: 24px;

    ${media.above.sm} {
        gap: 0;
    }
    ${media.above.md} {
        flex-direction: row;
        padding-bottom: 0;
        flex: 1 58.33333%;
    }
`;

const descriptionTextColumnStyles = css`
    flex: 1 100%;
    box-sizing: border-box;
    color: #000000;

    ${media.above.sm} {
        padding-bottom: 22px;
        padding-top: 16px;
    }
`;

const descriptionButtonStyles = css`
    flex: 1 0%;
    box-sizing: border-box;
    font-weight: 500;
    ${media.above.sm} {
        padding-left: 16px;
    }
`;

const locationStyles = css`
    flex: 1 16.66666%;
    padding: 0 ${token("space.200")} 0 ${token("space.200")};
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;

    img {
        vertical-align: bottom;
        width: 100%;
    }

    ${UNSAFE_media.below.md} {
        display: none;
    }
`;

export const UnleashBanner = () => {
    const intl = useIntl();
    const description = (
        <FormattedMessage
            id="LiftedBar.Unleash.description"
            defaultMessage={`Time is running out to get your free ticket for Atlassian Presents: Unleash using code <strong>ULLASTCHANCECOMP101</strong>! Learn how to solve the challenges your teams face with the tools your teams love.`}
            values={DEFAULT_VALUES}
        />
    );
    const ctaText = intl.formatMessage({
        id: "LiftedBar.Unleash.cta",
        defaultMessage: "Register now"
    });
    const ctaUrl =
        "https://events.atlassian.com/unleash/in-person?ref=Unleash&utm_source=marketing&utm_campaign=acquisitionwebliftedbar&utm_medium=web";

    return (
        <div css={backgroundStyles}>
            <div css={titleImageStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_Presents_Unleash_logo_banner.webp"
                    alt={intl.formatMessage({
                        id: "LiftedBar.Unleash.logoAltText",
                        defaultMessage: "Unleash text logo"
                    })}
                />
            </div>
            <div css={descriptionStyles}>
                <div css={descriptionTextColumnStyles}>
                    <p
                        css={css`
                            margin-bottom: 0;
                            margin-top: 0;
                        `}
                    >
                        {description}
                    </p>
                </div>
                <div css={descriptionButtonStyles}>
                    <Button
                        size={"small"}
                        dataEventProps={{
                            "data-event-component": "linkButton",
                            "data-event-container": "banner-link-button",
                            "data-event": "clicked",
                            "data-product-key": "jiraSoftware"
                        }}
                        url={ctaUrl}
                        css={css`
                            white-space: nowrap;
                            font-weight: 500;
                            ${UNSAFE_media.below.md} {
                                display: none;
                            }
                        `}
                        text={ctaText}
                    />
                    <Link
                        text={ctaText}
                        href={ctaUrl}
                        customLinkColor="g900"
                        doesArrowAnimate={true}
                        css={css`
                            ${media.above.md} {
                                display: none;
                            }
                        `}
                    />
                </div>
            </div>
            <div css={locationStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_PromoBannerGeo.webp"
                    alt={intl.formatMessage({
                        id: "LiftedBar.Unleash.location.imageAltText",
                        defaultMessage: "St. Nicholas Church in Amsterdam"
                    })}
                />
            </div>
        </div>
    );
};
